// extracted by mini-css-extract-plugin
module.exports = {"squareMainContent":"square_squareMainContent__N4Lsf"};